import styled from 'styled-components'
import { Row } from 'antd'

export const WrapRow = styled(Row)`
  margin-bottom: 8px;
`
